import { useEffect, useState } from 'react';

import {
  FIELD_NAME,
  Pages,
  SUGGESTED_PROMPT_QUERY_PARAM,
  THREAD_ID,
} from '@components/pages/AI/DeepResearch/constants';
import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';

const hideOneTrustFloatingIcon = () => {
  const oneTrustFloatingIcon: HTMLElement | null = document.getElementById('ot-sdk-btn-floating');
  if (oneTrustFloatingIcon) oneTrustFloatingIcon.style.display = 'none';
};

const useDeepResearchPageOperator = () => {
  const { Track: TrackWelcome } = useEventTracking({
    page: Page.DeepResearchWelcome,
  });
  const { Track: TrackThread } = useEventTracking({
    page: Page.DeepResearchThread,
  });

  const [page, setPage] = useState<Pages>(null);
  const [query, setQuery] = useState<string | null>(null);
  const [queryThreadID, setQueryThreadID] = useState<string | null>(null);
  const [suggestedPrompt, setSuggestedPrompt] = useState<string | null>(null);
  const [isTransitioning, setIsTransitioning] = useState<boolean>(false);

  useEffect(() => {
    function updateViewFromURL() {
      const searchParams = new URLSearchParams(window.location.search);
      const queryValue = searchParams.get(FIELD_NAME);
      const threadIDValue = searchParams.get(THREAD_ID);
      const suggestedPromptValue = searchParams.get(SUGGESTED_PROMPT_QUERY_PARAM);

      // Prefer threadID to query value if both are visible in the URL params
      if (threadIDValue?.length > 0) {
        setPage(Pages.Chatbot);
        setQueryThreadID(threadIDValue);
        hideOneTrustFloatingIcon();
      } else if (suggestedPromptValue?.length > 0) {
        setPage(Pages.Welcome);
        setSuggestedPrompt(suggestedPromptValue);
      } else if (queryValue?.length > 0) {
        setPage(Pages.Chatbot);
        setQuery(queryValue);
        hideOneTrustFloatingIcon();
      } else {
        setPage(Pages.Welcome);
      }
    }

    updateViewFromURL();

    const handlePopState = () => {
      updateViewFromURL();
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  const handlePageTransition = (newQuery: string) => {
    setIsTransitioning(true);

    hideOneTrustFloatingIcon();

    window.setTimeout(() => {
      setPage(Pages.Chatbot);
      setQuery(newQuery);
      setIsTransitioning(false);
    }, 500);
  };

  return {
    page,
    query,
    queryThreadID,
    suggestedPrompt,
    handlePageTransition,
    isTransitioning,
    TrackThread,
    TrackWelcome,
  };
};

export default useDeepResearchPageOperator;
